<template>
  <transition name="modal">
    <div
      class="modal-mask"
    >
      <div class="modal-wrapper">
        <div
          class="closable"
          @click="$emit('close')"
        />
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
            <div
              class="close"
              @click="$emit('close')"
            />
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      twoWay: true
    }
  }
}
</script>

<style scoped>

</style>
